<template>
    <td-dialog heigh="100px" :title="$t(title)" :before-close="userDialogClose" :visible.sync="dialogUserVisible" width="400px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formUserInfo" ref="formUserInfo" :label-position="labelPosition" :rules="rules">
            <el-form-item :label="$t('common.USERNAME')" class="itemStyle" :label-width="formLabelWidth" prop="userName">
                <td-input :disabled="autoDisabled" v-model="formUserInfo.userName"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.LOCK_STATE')" class="itemStyle" :label-width="formLabelWidth" prop="lockState">
                <td-select :disabled="autoDisabled" v-model="formUserInfo.locked" :options="options"></td-select>
            </el-form-item>
            <el-form-item :label="$t('common.UPPER')" class="itemStyle" :label-width="formLabelWidth" prop="upper">
                <td-tree-select
                    ref="TdUserTree"
                    :treeList="userList"
                    :lazyloading="true"
                    :defaultProps="defaultProps"
                    :isSingleCheck="isSingleCheck"
                    @queryData="queryUserTreeData"
                    :inputShow="false"
                    :imgloading="true"
                    v-model="formUserInfo.upper"
                    :nodeKey="nodeKey"
                    :params="params"
                    :multiple="false"
                ></td-tree-select>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formUserInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="userDialogClose">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import api from '../assets/api.js';
export default {
    props: ['title', 'dialogUserVisible', 'editItem', 'isAddData', 'selectOptions'],
    created() {
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
            this.autoDisabled = true;
        }
        // this.options = this.selectOptions
    },
    // 定义变量
    data() {
        return {
            formLabelWidth: '30%',
            // 用户信息
            formUserInfo: {
                userName: '',
                locked: '',
                upper: []
            },
            params: {
                rootCodes: ['BH-0001'],
                currentPage: 1,
                pageSize: 50
            },
            // 对表单进行数据验证
            rules: {
                userName: [
                    { required: true, message: this.$t('error.ERROR_INPUT_MENU_NAME'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.error_caption_max_length'), trigger: 'blur' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ]
            },
            defaultProps: {
                children: 'children',
                label: 'caption',
                id: 'id',
                imgName: 'sIcon',
                parentId: 'parentId'
            },
            nodeKey: 'id',
            isSingleCheck: true,
            // 锁定状态下拉列表
            options: [
                {
                    value: '1',
                    label: this.$t('common.LOCKED')
                },
                {
                    value: '0',
                    label: this.$t('common.NOT_LOCKED')
                }
            ]
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formUserInfo.userName = this.editItem.userName;
            this.formUserInfo.locked = this.editItem.locked === '' ? '0' : this.editItem.locked;
            if (!this.$util.isEmpty(this.editItem.upper)) {
                let obj = { id: this.editItem.upper, caption: this.editItem.upperName };
                this.formUserInfo.upper.push(obj);
            }
        },
        // 提交数据
        submitForm(formName) {
            let _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    let content = {
                        userName: _this.formUserInfo.userName,
                        lockState: _this.formUserInfo.lockState
                    };
                    let userNode = _this.$refs.TdUserTree.getSelectedNodes();
                    if (userNode) {
                        if (!userNode.typeId && userNode.typeId !== undefined && userNode.typeId !== '1000') {
                            _this.$message({ type: 'warning', showClose: true, message: '请选择正确的用户节点' });
                            return;
                        }
                        content.upper = userNode.userId;
                    }
                    content.userid = _this.editItem.userid;
                    api.editUserInfo(JSON.stringify(content), response => {
                        if (response.data.statusCode !== _this.$common.requestCode.SUCCESS_INFO_CODE) {
                            _this.$message({ type: 'warning', showClose: true, message: response.data.statusMessage });
                            _this.$log.error('dialoguser/editUserInfo', response.data.statusMessage);
                            return;
                        }
                        _this.$message({ type: 'success', showClose: true, message: _this.$t('common.MODIFY_SUCCESS') });
                        _this.userDialogClose();
                        /* 编辑或添加完成需调用查询接口 */
                        _this.$emit('btnQuery');
                    });
                }
            });
        },
        // 获取用户组织树形
        queryUserTreeData: function(item) {
            if (item.parentId === '' || item.parentId === null || item.parentId === undefined) {
                item.parentId = item.parentId = '';
            }
            let queryParam = {
                includeSelf: false,
                parentId: item.parentId,
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS,
                currentPage: item.currentPage,
                pageSize: item.pageSize,
                sysId: this.$common.systemInfo.systemId
            };
            var _this = this;
            api.findUserTree(JSON.stringify(queryParam), response => {
                if (response.status === _this.$common.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === _this.$common.requestCode.SUCCESS_INFO_CODE) {
                        if (response.data.content === null || response.data.content === undefined) {
                            return;
                        }
                        // 初始化树形数据
                        _this.$refs.TdUserTree.initData(response.data.content);
                    } else {
                        this.$log.error('/OrgManagerController/findTree', response.data.statusMessage);
                    }
                } else {
                    this.$message({ type: 'error', showClose: true, message: this.$t('common.OPERATION_FAIL') });
                    this.$log.error('/OrgManagerController/findTree', response);
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        userDialogClose() {
            this.$emit('userDialogClose');
            this.$refs['formUserInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
</style>
